import axiosPrivateMl from "./axiosPrivateMl"

export const fetchAdsLaunchValidationErrors = async (requestData) => {
  return axiosPrivateMl.post(`validate_fb_ads_launch`, requestData)
}
